import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Denunciar esta página',
  title: 'Relatar um problema nesta página',
  reasons: {
    'inaccurate-or-fabricated': 'Informação incorreta ou inventada',
    'wrong-product': 'Os produtos não correspondem à página',
    'sexually-explicit': 'Conteúdo sexualmente explícito',
    'regulated-product': 'Produto sob prescrição ou regulamentado',
    'dangerous-product': 'Produto perigoso',
    'ip-infringement': 'Viola meus direitos (marca/direitos autorais)',
    other: 'Outro motivo',
  },
  detail: 'Detalhes (opcional)',
  submit: 'Enviar denúncia',
  cancel: 'Cancelar',
  sent: 'Obrigado. Analisamos as denúncias em até 24 horas.',
  failed: 'Não foi possível enviar a denúncia. Tente novamente.',
};
